var _defs, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMeeting = function SvgMeeting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".meeting_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 16,
    x: 0.504,
    y: 0.5,
    className: "meeting_svg__a",
    rx: 1,
    ry: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.504 16.5v7M4.504 23.5l7-7 7 7M.504 4.5h23",
    className: "meeting_svg__a"
  })));
};
export { SvgMeeting as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6bm9uZTtzdHJva2U6Y3VycmVudENvbG9yO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPnByZXNlbnRhdGlvbi1ib2FyZDwvdGl0bGU+PHJlY3QgY2xhc3M9ImEiIHg9IjAuNTA0IiB5PSIwLjUiIHdpZHRoPSIyMyIgaGVpZ2h0PSIxNiIgcng9IjEiIHJ5PSIxIi8+PGxpbmUgY2xhc3M9ImEiIHgxPSIxMS41MDQiIHkxPSIxNi41IiB4Mj0iMTEuNTA0IiB5Mj0iMjMuNSIvPjxwb2x5bGluZSBjbGFzcz0iYSIgcG9pbnRzPSI0LjUwNCAyMy41IDExLjUwNCAxNi41IDE4LjUwNCAyMy41Ii8+PGxpbmUgY2xhc3M9ImEiIHgxPSIwLjUwNCIgeTE9IjQuNSIgeDI9IjIzLjUwNCIgeTI9IjQuNSIvPjwvc3ZnPg==";